import React from 'react';
import { func, oneOf, bool, string } from 'prop-types';
import classNames from 'classnames';

import * as styles from './styles/styles.module.scss';

const Button = ({ variant, disabled, onClick, classes, children, type }) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={classNames(styles[variant], classes)}
      data-testid={children}
      // eslint-disable-next-line react/button-has-type
      type={type}
    >
      {children}
    </button>
  );
};

export default Button;

Button.propTypes = {
  onClick: func,
  variant: oneOf(['primary', 'secondary', 'small', 'flat', 'tertiary', 'destructive-primary']).isRequired,
  disabled: bool,
  classes: string,
  type: oneOf(['button', 'submit', 'reset'])
};

Button.defaultProps = {
  disabled: false,
  classes: '',
  onClick: null,
  type: 'button'
};
